'use strict';

// Go to top button
$(function () {
  var topBtn = $('.js_pagetop');
  var hsize = $(window).height();

  $(window).scroll(function () {
    if ($(this).scrollTop() > hsize + 100) {
      topBtn.addClass('active');
    } else {
      topBtn.removeClass('active');
    }
  });

  topBtn.bind('click', function (event) {
    event.preventDefault();
    $('body,html')
      .stop()
      .animate(
        {
          scrollTop: 0
        },
        1000,
        'easeInQuart',
        function () {
          topBtn.removeClass('active');
        }
      );
  });
});
